import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a477f92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hot-grid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "hot-grid-container" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "iconfont icon-celiang1" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "changeLayer" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label title-label" }, "监控企业", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_leftDialogVue = _resolveComponent("leftDialogVue")!
  const _component_rightDialogVue = _resolveComponent("rightDialogVue")!
  const _component_menuH = _resolveComponent("menuH")!
  const _component_popWin = _resolveComponent("popWin")!
  const _component_switchControl = _resolveComponent("switchControl")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _withDirectives(_createElementVNode("div", { class: "title" }, _toDisplayString(_ctx.title), 513), [
      [_vShow, _ctx.title.length > 6]
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "employ",
        style: _normalizeStyle({ width: _ctx.mapWidth.mapLeftWidth })
      }, null, 4),
      _hoisted_2,
      _createElementVNode("div", {
        class: "employ",
        style: _normalizeStyle({ width: _ctx.mapWidth.mapRightWidth })
      }, null, 4)
    ]),
    _createVNode(_component_leftDialogVue, {
      onRowClick: _ctx.loadInitData,
      ref: "leftDialogVueRef",
      onLeftDialogHide: _ctx.leftDialogHide
    }, null, 8, ["onRowClick", "onLeftDialogHide"]),
    _withDirectives(_createVNode(_component_rightDialogVue, {
      ref: "rightDialogVueRef",
      gridDetailData: _ctx.gridDetailData,
      activeGridIndex: _ctx.activeGridIndex,
      activeGrid: _ctx.activeGrid,
      onCloseRightPanel: _ctx.closeRightPanel,
      onGridDetailClick: _ctx.gridDetailClick,
      onTabClick: _ctx.tabClick,
      onUpdateLeftTable: _ctx.updateLeftTable,
      onUpdateTicketDetail: _ctx.updateLeftTable
    }, null, 8, ["gridDetailData", "activeGridIndex", "activeGrid", "onCloseRightPanel", "onGridDetailClick", "onTabClick", "onUpdateLeftTable", "onUpdateTicketDetail"]), [
      [_vShow, _ctx.showRightPanel]
    ]),
    _createElementVNode("div", {
      class: "btn",
      style: _normalizeStyle(_ctx.showRightPanel ? 'right: 4.9rem': '')
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.activeRuler ? 'ruler active' : 'ruler'),
        title: "测距",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.rulerClick && _ctx.rulerClick(...args)))
      }, _hoisted_4, 2),
      _createElementVNode("ul", _hoisted_5, [
        _createElementVNode("ul", {
          class: _normalizeClass(_ctx.layerFlag ? 'layerOpen' : '')
        }, [
          _createElementVNode("li", {
            class: _normalizeClass(_ctx.currentMapLayer === 'sate' ? 'active': ''),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeMap('sate')))
          }, " 影像 ", 2),
          _createElementVNode("li", {
            class: _normalizeClass(_ctx.currentMapLayer === 'vector' ? 'active': ''),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeMap('vector')))
          }, " 矢量 ", 2),
          _createElementVNode("li", {
            class: _normalizeClass(_ctx.currentMapLayer === 'darkVector' ? 'active': ''),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeMap('darkVector')))
          }, " 深色 ", 2)
        ], 2),
        _createElementVNode("li", {
          class: "iconfont icon-layers layer",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.layerFlag ? _ctx.layerFlag = false : _ctx.layerFlag = true))
        })
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["monitor-company", _ctx.allCompanyShowFlag ? 'active' : '']),
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.allCompanyShow && _ctx.allCompanyShow(...args)))
      }, [
        _hoisted_6,
        _createElementVNode("i", {
          class: _normalizeClass(["iconfont icon-gongsi", _ctx.allCompanyShowFlag ? 'active' : '']),
          style: {"color":"#fff"}
        }, null, 2)
      ], 2),
      _withDirectives(_createVNode(_component_menuH, { onMapElementChange: _ctx.mapElementChange }, null, 8, ["onMapElementChange"]), [
        [_vShow, _ctx.timePlayerTenMinsPerm]
      ])
    ], 4),
    _createVNode(_component_popWin, {
      ref: "popupRef",
      onClose: _ctx.closeWinInfo
    }, null, 8, ["onClose"]),
    _withDirectives(_createVNode(_component_switchControl, {
      style: _normalizeStyle(_ctx.showRightPanel ? 'right: 4.85rem': ''),
      ref: "switchControlRef",
      class: _normalizeClass(_ctx.mapStyle),
      isAPictureSwitch: false,
      onSwitchChange: _ctx.switchChange
    }, null, 8, ["style", "class", "onSwitchChange"]), [
      [_vShow, _ctx.isSelectedMenu]
    ])
  ], 64))
}